import asset0 from './assets/blue-big.png';
import asset1 from './assets/blue-small.png';
import asset2 from './assets/sliver-big.png';
import asset3 from './assets/sliver-small.png';
import asset4 from './assets/gold-big.png';
import asset5 from './assets/gold-small.png';
import asset6 from './assets/platinum-big.png';
import asset7 from './assets/platinum-small.png';
import asset8 from './assets/diamond-big.png';
import asset9 from './assets/diamond-small.png';
import asset10 from './assets/icon-member-card1-block.png';
import asset11 from './assets/icon-member-card2-block.png';
import asset12 from './assets/icon-member-card3-block.png';
import asset13 from './assets/icon-member-card4-block.png';
import asset14 from './assets/icon-member-card5-block.png';
import asset15 from './assets/ppqy-logo1-1-on.png';
import asset16 from './assets/ppqy-logo1-2-on.png';
import asset17 from './assets/ppqy-logo1-3-on.png';
import asset18 from './assets/ppqy-logo1-4-on.png';
import asset19 from './assets/ppqy-logo1-5-on.png';
import asset20 from './assets/ppqy-logo1-6-on.png';
import asset21 from './assets/ppqy-logo1-1.png';
import asset22 from './assets/ppqy-logo1-2.png';
import asset23 from './assets/ppqy-logo1-3.png';
import asset24 from './assets/ppqy-logo1-4.png';
import asset25 from './assets/ppqy-logo1-5.png';
import asset26 from './assets/ppqy-logo1-6.png';
import asset27 from './assets/ppqy-logo2-1-on.png';
import asset28 from './assets/ppqy-logo2-2-on.png';
import asset29 from './assets/ppqy-logo2-3-on.png';
import asset30 from './assets/ppqy-logo2-1.png';
import asset31 from './assets/ppqy-logo2-2.png';
import asset32 from './assets/ppqy-logo2-3.png';

export default {
  'blue-big.png': asset0,
  'blue-small.png': asset1,
  'sliver-big.png': asset2,
  'sliver-small.png': asset3,
  'gold-big.png': asset4,
  'gold-small.png': asset5,
  'platinum-big.png': asset6,
  'platinum-small.png': asset7,
  'diamond-big.png': asset8,
  'diamond-small.png': asset9,
  'icon-member-card1-block.png': asset10,
  'icon-member-card2-block.png': asset11,
  'icon-member-card3-block.png': asset12,
  'icon-member-card4-block.png': asset13,
  'icon-member-card5-block.png': asset14,
  'ppqy-logo1-1-on.png': asset15,
  'ppqy-logo1-2-on.png': asset16,
  'ppqy-logo1-3-on.png': asset17,
  'ppqy-logo1-4-on.png': asset18,
  'ppqy-logo1-5-on.png': asset19,
  'ppqy-logo1-6-on.png': asset20,
  'ppqy-logo1-1.png': asset21,
  'ppqy-logo1-2.png': asset22,
  'ppqy-logo1-3.png': asset23,
  'ppqy-logo1-4.png': asset24,
  'ppqy-logo1-5.png': asset25,
  'ppqy-logo1-6.png': asset26,
  'ppqy-logo2-1-on.png': asset27,
  'ppqy-logo2-2-on.png': asset28,
  'ppqy-logo2-3-on.png': asset29,
  'ppqy-logo2-1.png': asset30,
  'ppqy-logo2-2.png': asset31,
  'ppqy-logo2-3.png': asset32,
};
